import {
    FieldsArray,
    WireUploadFormatUIModelReturn,
} from '@treasury/domain/wires/mappings/wire-upload-formats.mappings';

export const defaultFormat: (fields: FieldsArray) => WireUploadFormatUIModelReturn = (
    fields: FieldsArray
) => ({
    id: 0,
    name: '',
    title: 'New Wire Upload Format',
    type: 'Delimited',
    delimiter: ',',
    excludeHeaderRows: 0,
    excludeFooterRows: 0,
    itemAmountFormat: 'DecimalIncluded',
    effectiveDateFormat: 'mm/dd/yyyy',
    containers: [
        { id: 'in', title: 'Drag and drop items to reorder columns', active: 'true' },
        {
            id: 'out',
            title: 'Drag and drop optional items to the space above to activate',
            active: 'false',
        },
    ],
    tiles: [
        /**
         * Use the fields from /wire/fileFormatField which should
         * contain the comprehensive list of all tiles available
         */
        ...fields.flat(),
        {
            id: 100,
            order: undefined,
            width: 1,
            type: 'filler',
            name: 'Filler Tile',
            optional: 'true',
            required: 'false',
        },
    ],
});
